<template>
	<sui-form @submit.prevent>
		<sui-form-field>
			<label
				v-if="!sinTitulo"
				:class="{ [$style.titulo]: true, [$style.boldFont]: true }"
			>
				{{ titulo }}
			</label>
			<sui-dropdown
				ref="select"
				fluid
				:class="{ disabled: disabled }"
				:options="optionsCarreras"
				:placeholder="placeholder"
				:value="value"
				selection
				search
				:loading="getLoading"
				:no-results-message="mensajeVacio"
				@input="onInput"
			/>
			<div style="margin-top: 5px;">
				<span v-show="error" :class="$style.danger">
					<sui-icon name="exclamation circle" />Dato obligatorio
				</span>
			</div>
		</sui-form-field>
	</sui-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	props: {
		placeholder: {
			type: String,
			default: 'Selecciona una carrera'
		},
		titulo: {
			type: String,
			default: 'Carrera'
		},
		mensajeVacio: {
			type: String,
			default: 'No se encontraron carreras'
		},
		error: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		value: {
			type: [String, Object],
			default: null
		},
		sinTitulo: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			carrera: null
		};
	},

	computed: {
		...mapGetters('carreras', ['getCarreras', 'getLoading']),
		optionsCarreras: function() {
			return this.getCarreras.map((c, index) => ({
				text: `${c.claveCarrera} - ${c.nombreCorto}`,
				value: c.claveCarrera
			}));
		}
	},
	created() {},
	mounted() {
		this.inicializar();
		this.$watch('$refs.select.open', (open) => {
			if (!open) this.$refs.select.filter = '';
		});
	},
	methods: {
		...mapActions('carreras', ['inicializar']),
		onInput(val) {
			this.$emit('input', val);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.titulo {
	font-size: 14px !important;
	color: #5c5d5d !important;
}
.danger {
	color: #9f2241 !important;
}
</style>
